import common from "./common";
import login from "./login";
import user from "./user";

import cases from "./case";
import brand from "./brand";
import product from "./product";
import store from "./store";
import calculator from "./calculator";
import template from "./template";
import share from "./share";
import school from "./school";

export default {
    common, login, user, cases, brand, product, store, calculator, template, share, school
};


// WEBPACK FOOTER //
// ./src/request/apis/index.js